import * as THREE from "three";

interface RBFVolume3DProps {
  geometry: THREE.BufferGeometry | null;
  visible?: boolean;
  opacity?: number;
  color?: string;
}

/**
 * RBFVolume3D: Renders a pre-computed RBF isosurface mesh.
 * The geometry is computed once on demand (button click), not every frame.
 */
export function RBFVolume3D({
  geometry,
  visible = true,
  opacity = 0.5,
  color = "#ff2200",
}: RBFVolume3DProps) {
  if (!geometry || !visible) return null;

  return (
    <mesh geometry={geometry}>
      <meshStandardMaterial
        color={color}
        transparent={opacity < 1}
        opacity={opacity}
        side={THREE.DoubleSide}
        roughness={0.7}
        metalness={0.1}
      />
    </mesh>
  );
}
